import { render, staticRenderFns } from "./Payment.yaml?vue&type=template&id=1415b454&component"
import script from "./Payment.yaml?vue&type=script&lang=ts&component"
export * from "./Payment.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports